<script>
	import Contact from "./Contact.svelte";
	import Checkbox from "./Checkbox.svelte";
	import Select from "./Select.svelte";

	import { individualCapacityTypes } from "../config";
	import ContactModel from "../models/Contact";
	import AddressModel from "../models/Address";

	export let contact = null;
	export let individual = null;
	export let capacity;
	export let employeeRole;
	export let authorisedToAct = false;
	export let disabled = null;
	export let required = null;

	let mainContactName = "Main Contact";
	$: {
		if (contact.FirstName && contact.Surname) {
			mainContactName = `${contact.FirstName} ${contact.Surname}`;
		} else if (contact.FirstName) {
			mainContactName = contact.FirstName;
		} else if (contact.Surname) {
			mainContactName = contact.Surname;
		} else {
			mainContactName = "Main Contact";
		}
	}

	const sameContactDetails = () => {
		individual.PhoneNumber = contact.PhoneNumber;
		individual.EmailAddress = contact.EmailAddress;
		Object.keys(contact.Address).forEach((key, i) => {
			individual.Address[key] = contact.Address[key];
		});
	};

	const initialise = () => {
		if (!individual) {
			individual = getIndividual();
		}
	};

	const getIndividual = () => {
		let individual = new ContactModel();
		individual.Address = new AddressModel();

		return individual;
	};

	initialise();
</script>

{#if individual}
	<div class="form-row">
		<div class="col-md-6">
			<h3>Individuals Details</h3>
		</div>
		<div class="col-md-6 last">
			{#if !disabled}
				<button
					class="btn btn-primary btn-add-holdings btn-sm"
					on:click|preventDefault={() => sameContactDetails(0)}
					>Same contact details as {mainContactName}</button
				>
			{/if}
		</div>
	</div>

	<Contact
		bind:salutation={individual.Title}
		bind:firstName={individual.FirstName}
		bind:surname={individual.Surname}
		bind:emailAddress={individual.EmailAddress}
		bind:phoneNumber={individual.PhoneNumber}
		bind:address={individual.Address}
		{disabled}
		{required}
		idPrefix="i1"
	></Contact>
{/if}

<div class="form-row">
	<div class="form-group col-md-6">
		<label for="capacity">Capacity</label>
		<Select
			{disabled}
			bind:value={capacity}
			id="capacity"
			optionList={individualCapacityTypes}
			textProperty="name"
			valueProperty="name"
		></Select>
	</div>
</div>

<div class="form-row">
	<div class="col-md-12">
		<Checkbox
			{disabled}
			bind:checked={authorisedToAct}
			label="I am authorised to act on behalf of the Individual"
			{required}
			id="authjh"
		></Checkbox>
	</div>
</div>
